<ng-container *ngIf="!oClinic">
    <button mat-icon-button matTooltip="Clinic Now" (click)="clinicNowDrawer.toggle()" #clinicNow>
        <mat-icon class="icon-size-6" [svgIcon]="'davesa:clinic'"></mat-icon>
    </button>

    <davesa-drawer class="z-999 w-screen min-w-screen sm:w-100 sm:min-w-100" fixed [mode]="'over'"
        [name]="'clinicNowDrawer'" [position]="'right'" #clinicNowDrawer>
        <div class="bg-card flex w-full flex-col overflow-auto h-full">
            <!-- Header -->
            <div class="clinic-now-header flex flex-0 cursor-pointer items-center justify-start bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-4">
                <div class="flex flex-auto items-center justify-center">
                    <div class="flex w-16 flex-0 items-center justify-center">
                        <mat-icon class="icon-size-8 m-1 text-sky-400" [svgIcon]="'davesa:clinic'"></mat-icon>
                    </div>
                    <div class="text-secondary text-lg font-medium">
                        Clinic Now
                    </div>
                    <button class="ml-auto mr-4" mat-icon-button (click)="clinicNowDrawer.close()">
                        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                    </button>
                </div>
            </div>
            
            <!-- Content -->
            <div class="flex flex-auto flex-col overflow-hidden bg-gray-50 dark:bg-transparent">
                <div class="h-full w-full flex-0 overflow-y-auto overscroll-y-contain p-4"
                    davesaScrollbar [davesaScrollbarOptions]="{ wheelPropagation: false }">
                    <!-- Clinic Now List Component -->
                    <clinic-now-list [isInSidePanel]="true"></clinic-now-list>
                </div>
            </div>
        </div>
    </davesa-drawer>
</ng-container>

<ng-container *ngIf="oClinic">
    <main class="flex flex-col items-center justify-center w-full">
        <div class="grid grid-cols-3 2xl:grid-cols-12 xl:grid-cols-12 lg:grid-cols-12 md:grid-cols-12 sm:grid-cols-5 xs:grid-cols-4 w-full
            place-content-center place-items-center 
        " *ngIf="(visitsBoard()) as visits; else noVisits" [class.hide]="appearance!=='board' || !visits.length">
            <div *ngFor="let visit of visits | sortByIndex: 'asc'">
                <div class="pt-2 text-center  
                xl:w-12 lg:w-14 md:w-12 sm:w-12 xs:w-10 w-xs 
                xl:text-[10px] lg:text-[8px] md:text-[8px] sm:text-[8px] xs:text-[6px] text-[6px]">{{
                    visit.status.name }}</div>
                <a [matMenuTriggerFor]="studiesListMenu" #studiesListMenuTrigger="matMenuTrigger"
                    [matTooltip]="visit.status.tooltip" data-popover-target="menu-1" data-popover-nested="true" class="
                            bg-card aspect-square rounded-lg p-2 shadow flex flex-col items-center justify-center 
                            xl:w-14 lg:w-12 md:w-12 sm:w-12 xs:w-8 w-8 
                            xl:h-14 lg:h-12 md:h-12 sm:h-12 xs:h-8 h-8 
                            hover:bg-amber-500
                            {{ visit.status.bgClass }}">
                    <div class="flex flex-col items-center justify-center {{ visit.status.textClassContrast }}">
                        <div class="font-bold xl:text-4xl lg:text-3xl md:text-2xl sm:text-xl xs:text-lg text-xl p-4 text-center
                                            {{ visit.status.textClassContrast }}">
                            <div class="text-4xl font-bold leading-none tracking-tight sm:text-4xl align-middle
                                                xl:text-4xl lg:text-4xl md:text-2xl sm:text-2xl xs:text-2xl text-xl 
                                                {{ visit.status.textClassContrast }}">
                                {{ visit.visitCount }}
                            </div>
                        </div>
                    </div>
                </a>
                <mat-menu #studiesListMenu="matMenu" [overlapTrigger]="false" role="menu" (mouseenter)="loadData()">
                    <div class="flex flex-row w-full text-lg items-center uppercase justify-center font-medium p-3 
                        {{ visit.status.bgClass }} {{ visit.status.textClassContrast }}">
                        <div class="basis-100">
                            {{ visit.status.name }}
                        </div>
                    </div>
                    <div class="visitMenu">
                        @for (
                        study of visit.value;
                        track trackByFn(i, study);
                        let i = $index
                        ) {
                        @if(study.visits > 0) {
                        <button mat-menu-item class="flex flex-row w-full text-md font-medium p-1 hover:bg-amber-400"
                            [matMenuTriggerFor]="participantVisitMenu" #participantVisitMenuTrigger="matMenuTrigger"
                            (mouseenter)="getVisits(study)">
                            <div class="basis-1/5 ml-3 text-xl items-center uppercase justify-center font-bold">
                                {{ study.visits }}
                            </div>
                            <div class="basis-full">
                                {{ study.number }}
                            </div>
                        </button>
                        }
                        <mat-menu #participantVisitMenu="matMenu" [overlapTrigger]="false" (mouseenter)="menuEnter()"
                            (mouseleave)="menuLeave()">
                            <ng-container *ngIf="!(visits$ | async); else menuContent">
                                <button mat-menu-item>
                                    <mat-spinner color="warn" class="w-10 h-10"></mat-spinner>
                                    <div class="ml-3">Loading...</div>
                                </button>
                            </ng-container>

                            <ng-template #menuContent>
                                <div class="visitMenu">
                                    @if (visits$ | async; as visits) {
                                    @if (visits.length > 0) {
                                    @for (
                                    visit of visits;
                                    track trackByFn(i, visit);
                                    let i = $index
                                    ) {
                                    <a mat-menu-item
                                        class="flex flex-row w-full text-md font-medium p-1 hover:bg-amber-400"
                                        *ngFor="let visit of visits; trackBy: trackByFn; let i = index"
                                        (click)="openVisit(visit)"> <mat-icon>
                                            <span class="material-symbols-outlined">person</span>
                                        </mat-icon>
                                        <span>{{ visit.subject.first_name }} {{ visit.subject.last_name }}:
                                            {{ visit.subject.subject_id }} -
                                            {{ visit?.study_schedule_visit.name }}</span>
                                    </a>
                                    <div class="divider"></div>
                                    }
                                    }
                                    }
                                </div>
                            </ng-template>
                        </mat-menu>
                        }
                    </div>
                </mat-menu>
            </div>
        </div>
    </main>
</ng-container>